import type { IntegrationStepConfig } from '@/types/automationSteps.ts';
import type { IntegrationActionConfig } from '@/types/integrations.ts';

export const withBrowserModelSelection = (
  config: IntegrationStepConfig,
  actionConfig: IntegrationActionConfig,
): IntegrationStepConfig => {
  if (
    config.integration_type !== 'web-browser'
    || config.action_type !== 'web_browser'
    || !actionConfig.fields.some((field) => field.id === 'browser_model_mode')
  ) {
    return config;
  }

  const storedMode = config.config_values.fields.find((field) => field.field_id === 'browser_model_mode');
  const rawMode = storedMode?.value;
  const mode = rawMode == null || rawMode === '' ? 'default' : rawMode;
  const fields = config.config_values.fields.map((field) => {
    if (field.field_id === 'browser_model') {
      return { ...field, is_hidden: mode !== 'custom' };
    }
    if (field.field_id === 'browser_model_mode') {
      return { ...field, value: mode };
    }
    return field;
  });
  if (!storedMode) {
    fields.push({
      field_id: 'browser_model_mode',
      value: mode,
      is_hidden: false,
      is_disabled: false,
      errors: [],
    });
  }
  if (
    !fields.some((field) => field.field_id === 'browser_model')
    && actionConfig.fields.some((field) => field.id === 'browser_model')
  ) {
    fields.push({
      field_id: 'browser_model',
      value: '',
      is_hidden: mode !== 'custom',
      is_disabled: false,
      errors: [],
    });
  }
  return { ...config, config_values: { fields } };
};
